<template>
  <div class="savepwdmodelbox">
    <div v-if="!isSuccess">
      <h3 class="mb-3">修改密码</h3>
      <hr class="mb-5">
      <div class="input-group mb-3">
        <input v-model="yzm" type="text" class="form-control form-control-lg" placeholder="通过预留手机号">
        <div class="input-group-append">
          <button v-if="!isSend" @click="getYzmFun" style="background:#FFFFFF;border: 1px solid #CED4DA;border-left: 0;" class="btn btn-light">
            <i style="font-size: 15px;" v-if="isLoadingYzm" class='iconfont icon-jiazai xuanzhuan text-success'></i>
            获取验证码
          </button>
          <button v-if="isSend" style="background:#FFFFFF;border: 1px solid #CED4DA;border-left: 0;" class="btn btn-light text-danger">
            {{isSendTime}}秒
          </button>
        </div>
      </div>
      <div class="form-group">
        <label>密码</label>
        <input type="password" v-model="pwd" class="form-control form-control-lg">
      </div>
      <div class="form-group mb-5">
        <label>重复密码</label>
        <input type="password" v-model="repwd" class="form-control form-control-lg">
      </div>
      <button type="submit" class="btn btn-primary btn-block btn-lg btn-round" @click="loginFun">
        <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
        修改密码
      </button>
    </div>
    <div class="isSuccessBox" v-else>
      <i class="iconfont icon-chenggong text-success"></i>
      <span>修改成功</span>
    </div>
  </div>
</template>

<script>
import generalMix from '@/util/mix/general';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'savepwdmodelbox',
  props:['apiCrmdatainfo'],
  mixins: [generalMix],
  data () {
    return {
      pwd: '',
      repwd: '',
      yzm: '',
      isSuccess: false,
      isLoading: false,
      isLoadingYzm: false,
      isSend: false,
      isSendTime: 60,
      timer: null
    }
  },
  methods:{
    // 找回密码
    getYzmFun() {
      return window.swal({
        title: '获取验证码',
        content: '单个账号每天仅能获取5次',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          // 加载中
          this.isLoadingYzm = true;
          resultCommons.apiSendcode(this,{user:this.localUser.user}).then(app=>{
            if(app.state === 200){
              // 成功
              this.isSend = true;
              this.timer = null;
              this.startCountdown();
              this.$message.showMsgBox({ type: 'success', content: app.message });
            }else{
              // 失败
              this.isSend = false;
              this.timer = null;
              this.$message.showMsgBox({ type: 'warning', content: app.message });
            }
            this.isLoadingYzm = false;
            this.isSendTime = 60;
            this.apiCrmdatainfo();
          });
        }
      });
    },
    // 登录
    loginFun() {
      EventBus.$emit('globalLoadingFun', {bool:true,loading:false});
      this.isLoading = true;
      // 可以执行登录
      resultCommons.apiSavepwd(this, { user: this.localUser.user, pwd: this.pwd , repwd: this.repwd , yzm: this.yzm }).then(app=>{
        if(app.state === 200){
          this.$message.showMsgBox({ type: 'success', content: app.message });
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          // 切换为修改成功页面
          this.isSuccess = true;
        }else{
          EventBus.$emit('globalLoadingFun', {bool:false,loading:false});
          this.isLoading = false;
          this.$message.showMsgBox({ type: 'warning', content: app.message });
        }
      });
    },
    // 开始倒计时函数
    startCountdown() {
      this.timer = setInterval(() => {
        if (this.isSendTime > 1) {
          this.isSendTime--;
        } else {
          this.isSend = false;
          this.timer = 60;
          clearInterval(this.timer);
        }
      }, 1000);
    }
  },
  mounted() {
  },
  beforeDestroy() {
    // 清除计时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  destroyed() {
  }
}
</script>

<style scoped lang='less'>

.savepwdmodelbox {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  background: #FFFFFF;
  color: #000000;
  width: 480px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  border-radius: 1rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  overflow-y: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  padding: 30px;
  div.isSuccessBox{
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    i{
      font-size: 56px;
    }
    span{
      margin-top: 50px;
      font-size: 16px;
    }
  }
}
@media (max-width: 767px) {
  .savepwdmodelbox {
    width: 80vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/user/Savepwd.vue